declare const jQuery: any;
const $ = jQuery;

export function initVideoPopup(): void
{
	$("[data-video-popup-html]").closest("[data-popup]").on("opened", function () {
		const $popup = $(this);
		const html: string = $popup.find("[data-video-popup-html]").html();
		$popup.find(".popup-content").html(html);
	}).on("closed", function () {
		const $popup = $(this);
		$popup.find(".popup-content").empty();
	});
}
